import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../../context";

interface PopulateRequestWithTemplateProps {
  requestId: string;
  templateId: string;
  patientUuid: string;
}

export const usePopulateRequestWithTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      requestId,
      templateId,
      patientUuid,
    }: PopulateRequestWithTemplateProps) => {
      return api({
        method: "POST",
        url: `/requests/${requestId}/prescriptions/template`,
        data: JSON.stringify({ templateId, patientUuid }),
      });
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["request", variables.requestId],
      });
    },
  });
};
